export enum ELocalStorageKeys {
  LANGUAGE = "locale",
  TOKEN = "accessToken",
  PERSIST = "persist:root",
  PATIENT = "patient",
  ACCOUNT_STATUS = "accountStatus",
}
